export class PetType{
    pet_type_label:string;
    icon:string;
    id:number;
}
export class OptionsPet{
    pet_types:PetType[]=[];
}
